const kinds = {
	Waterhoogte: "Waterhoogte",
	Waterafvoer: "Waterafvoer"
}

export default kinds;
